import React, { useEffect, useState } from 'react'
import { Button } from 'components/Button';
import Lottie, { Options } from 'react-lottie'

import heartAnimation from 'assets/animations/lottie_checkup_01.json';
import quizAnimation from 'assets/animations/lottie_checkup_02.json';
import doctorAnimation from 'assets/animations/lottie_checkup_03.json';
import ageRangeAnimation from 'assets/animations/lottie_checkup_04.json';

import { Card } from 'components/Card/Card';
import { cdn } from 'core/cdn';

import Styles from './PreventionTutorial.module.scss'
import { Title } from 'components/Title/Title';
import { languages } from 'locales/languages';
import { useDispatch } from 'react-redux';
import SurveyActions from "containers/Survey/services/actions";
import { useLocation, useNavigate } from 'react-router';
import { SURVEY_PAGE } from 'core/constants';
import { BP_PATH } from 'containers/Survey/models';
import { Steps } from 'components/Steps';
import PreviousButton from 'components/Previous/PreviousButton';
import { useStepper } from "components/Steps/hooks"

const defaultOptions: Options = {
  loop: true,
  autoplay: true,
  animationData: heartAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  }
}

const INFO_PAGE = 1
const RELATION_PAGE = 2;
const AGE_RANGE_PAGE = 3;
const FILL_A_FORM_PAGE = 4;
const OBJECTIVE_PAGE = 5;

// Intro: right after the BP pathway choice, before the pharmacist confirmation. Info: after "Sur la borne".
export const INTRO_PAGES = [INFO_PAGE, RELATION_PAGE]
export const INFO_PAGES = [AGE_RANGE_PAGE, FILL_A_FORM_PAGE, OBJECTIVE_PAGE]

const PreventionTutorial = ({ pages }: { pages: number[] }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fromEnd = Boolean((useLocation().state as { fromEnd?: boolean } | null)?.fromEnd)
  const [index, setIndex] = useState<number>(fromEnd ? pages.length - 1 : 0);
  const currentPage = pages[index]
  const { current, totalSteps, insideStep, totalInsideSteps } = useStepper({
    totalSteps: pages.length, current: index + 1
  })

  useEffect(() => {
    setIndex(fromEnd ? pages.length - 1 : 0)
  }, [pages, fromEnd])
  return <div>
          <Steps
            current={current}
            insideStep={insideStep}
            totalInsideSteps={totalInsideSteps}
            totalSteps={totalSteps}
          />
          <PreviousButton onClick={() => {
            if (index > 0) return setIndex(index - 1)
            if (pages === INTRO_PAGES) {
              dispatch(SurveyActions.previous())
            } else {
              // previous() skips redirect steps: jump back to the channel choice explicitly
              dispatch(SurveyActions.jumpTo(BP_PATH.prevention_handoff as any))
            }
            navigate(SURVEY_PAGE, { replace: true })
          }} />
            <Card>
                <div className={Styles.CardContainer}>
                  {
                    (currentPage === INFO_PAGE) && (<><Lottie options={defaultOptions} style={{ width: 300 }} /><div className={Styles.CarouselInfo}>
                    <div>{languages.the}{" "} <b>{languages.prevention}</b>{" "}{languages.isAProgramOfMinistry}{" "}<b>{languages.takeStockHealth}</b></div>
                    <br />
                    {languages.itIs}{" "}<b>{languages.hundredPourcentFree}</b>{" "}{languages.and.toLowerCase()}{" "}<b>{languages.withoutAdvance}</b>
                  </div></>)
                  }
                  {
                      currentPage === RELATION_PAGE && (
                      <div>
                        <Lottie options={{...defaultOptions, animationData: doctorAnimation}} style={{ width: 300 }} />
                        <div className={Styles.CarouselInfo}>
                          {languages.youWillBenefit}{" "}<b>{languages.healthAdvice}</b>
                        </div>
                      </div>
                      )
                  }
                  {
                    // @TODO => languages
                    (currentPage === AGE_RANGE_PAGE) && (
                      <div className={Styles.CardContainer}>
                        <Lottie options={{ ...defaultOptions, animationData: ageRangeAnimation }} style={{ width: 300 }} />
                        <div className={Styles.CarouselInfo}>
                          Le bilan prévention est destiné à toutes les personnes dans les <b>tranches d'âge suivantes :</b>
                          <br />
                          <div style={{marginTop: '50px'}}>18-25 ans / 45-50 ans / 60-65 ans / 70-75 ans</div>
                        </div>
                      </div>  
                    )
                  }
                  {
                    currentPage === FILL_A_FORM_PAGE && (
                      <><Lottie options={{ ...defaultOptions, animationData: quizAnimation }} style={{ width: 300 }} /><div className={Styles.CarouselInfo}>
                      {languages.youreGonna}{" "}<b>{languages.fillAForm}</b>{" "}{languages.aboutFortyQuestion}{" "}<b>{languages.lessThanTenMinutes}</b> {" "}{languages.toAnswer}
                    </div></>
                    )
                  }
                  </div>
                  {
                    currentPage === OBJECTIVE_PAGE && (
                    <div>
                      <Title text={<><b>{languages.objectiveOf} </b>{" "} {languages.isSimple}</>}></Title>
                      <div className={Styles.ObjectiveContainer}>
                        <div className={Styles.InfoCard}>
                          <img src={cdn("/images/prevention/checkup_reason_1.png")} alt="advice" width={160} style={{ padding: '10px' }} />
                          <div style={{padding: '25px', fontSize: '34px'}}>
                            {languages.getInitialAdvice}
                          </div>
                        </div>
                        <div className={Styles.InfoCard}>
                          <img src={cdn("/images/prevention/checkup_reason_2.png")} alt="become_aware" width={160} style={{ padding: '10px' }} />
                          <div style={{padding: '25px', fontSize: '34px'}}>
                            {languages.becomeAwareOf}
                          </div>
                        </div>
                        <div className={Styles.InfoCard}>
                          <img src={cdn("/images/prevention/checkup_reason_3.png")} alt="take_knowledge" width={160} style={{ padding: '10px' }} />
                          <div style={{padding: '25px', fontSize: '34px'}}>
                            {languages.acknowledgeThings}
                          </div>
                        </div>
                      </div>
                    </div>
                    )
                  }
                
              <div className={Styles.InfoButtons}>
                <Button type="primary" onClick={() => {
                  if (index === pages.length - 1) {
                    dispatch(SurveyActions.next())
                    navigate(SURVEY_PAGE, { replace: true })
                  } else {
                    setIndex(index + 1)
                  }
                }}>{languages.next}</Button>
              </div>
            </Card>
  </div>
}

export default PreventionTutorial;